import React from "react";
import { format, parse, isValid } from "date-fns";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// value: ISO date string "YYYY-MM-DD" or "" ; onChange(nextIso: string)
export function DatePicker({ value, onChange, placeholder = "Pick a date", clearable = false, testid }) {
  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const display = parsed && isValid(parsed) ? format(parsed, "dd MMM yyyy") : "";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={cn(
            "h-10 w-full inline-flex items-center justify-between gap-2 px-3 border border-[#E5E7EB] bg-white text-sm rounded-none",
            "hover:border-[#0F172A] focus:outline-none focus:border-[#0F172A] transition-colors",
            !display && "text-[#9CA3AF]"
          )}
        >
          <span className="flex items-center gap-2 truncate">
            <CalendarIcon className="h-4 w-4 text-[#6B7280] shrink-0" />
            {display || placeholder}
          </span>
          {clearable && display && (
            <X
              className="h-3.5 w-3.5 text-[#6B7280] hover:text-[#EF4444] shrink-0"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              data-testid={testid ? `${testid}-clear` : undefined}
            />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-none" align="start">
        <Calendar
          mode="single"
          selected={parsed}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
